(function () {
  var track = document.querySelector(".marquee__track");
  var sourceList = track && track.querySelector(".marquee__list");

  if (!track || !sourceList) {
    return;
  }

  var sourceHTML = sourceList.innerHTML;

  function buildMarquee() {
    while (track.children.length > 1) {
      track.removeChild(track.lastElementChild);
    }

    sourceList.innerHTML = sourceHTML;

    while (sourceList.scrollWidth < window.innerWidth) {
      sourceList.insertAdjacentHTML("beforeend", sourceHTML);
    }

    var clone = sourceList.cloneNode(true);
    clone.setAttribute("aria-hidden", "true");
    track.appendChild(clone);
  }

  buildMarquee();
  window.addEventListener("resize", buildMarquee);
})();
